import React from 'react';
import Raven from 'raven-js';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import routeConstants from './utils/routeConstants';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    window.onerror = () => {
      this.props.dispatch(push(routeConstants.ERROR_PAGE));

      return false;
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
    this.props.dispatch(push(routeConstants.ERROR_PAGE));
  }

  render() {
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired
};

ErrorBoundary.defaultProps = {
  children: null
};

export default withRouter(connect()(ErrorBoundary));



// WEBPACK FOOTER //
// ./src/ErrorBoundary.js